import axios from 'axios'
import appConfig from '@/service/config'
import userService from '@/service/userService'

function all() {
    return axios({
        method: 'get',
        url: appConfig.baseUrl + '/group/all',
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
}

function edit(params) {
  return axios({
    method: 'post',
    url: appConfig.baseUrl + '/group/edit',
    data: params,
    headers: {
      Authorization: userService.getAuthHeader()
    }
  })
}

function add(params) {
  return axios({
    method: 'post',
    url: appConfig.baseUrl + '/group/add',
    data: params,
    headers: {
      Authorization: userService.getAuthHeader()
    }
  })
}

function deleteGroup(params){
  return axios({
    method: 'post',
    url: appConfig.baseUrl + '/group/delete',
    data: params,
    headers: {
      Authorization: userService.getAuthHeader()
    }
  })
}

function getAllProductNames() {
  return axios({
    method: 'get',
    url: appConfig.baseUrl + "/product/allNames",
    headers: {
      Authorization: userService.getAuthHeader()
    }
  })
}

export default {
    "all": all,
    "add": add,
    "delete": deleteGroup,
    "edit": edit,
    "getAllProductNames": getAllProductNames
}


// WEBPACK FOOTER //
// ./src/components/group-product/GroupProductRestClient.js